import tingle from 'tingle.js';
import Swiper, { Navigation } from "swiper";

class TeamCardsSwiperModal {
    constructor(teamImageCards) {
        this.teamImageCards = teamImageCards
    }

    init() {
        if (!this.teamImageCards.length) return;
        this.teamImageCards.forEach(card => {
            card.addEventListener('click', this.openModal.bind(this))
        })
    }

    getTeamMemberData(card) {
				const intro = card.parentElement.querySelector('.js-team-member__intro')
        return {
            name: card.dataset.name,
            jobTitle: card.dataset.jobTitle,
            intro: intro ? intro.innerHTML : '',
            memberImageUrl: card.dataset.memberImageUrl,
            memberImageTitle: card.dataset.memberImageTitle
        };
    }
    getTeamMemberDataArray() {
        return this.teamImageCards.map(card => this.getTeamMemberData(card));
    }

    openModal(e) {
        e.preventDefault();
        e.stopPropagation();
        const modal = new tingle.modal({
            closeMethods: ['overlay', 'button', 'escape'],
            closeLabel: "Close",
            cssClass: ['team-modal'],
            onOpen: () => {
                this.createModalContent(modal, e.currentTarget)
            },
            onClose: () => {
                this.destroySwiper(modal)
                modal.destroy()
            }
        });
        modal.open();
    }

    destroySwiper(modal) {
        const swiper = modal.modal.querySelector('.swiper-container');
        if (swiper) {
            swiper.swiper.destroy(true, true);
        }
    }

    createModalContent(modal, card) {
        modal.setContent(`
            <div class="swiper-container team-modal__swiper">
                <div class="swiper-wrapper team-modal__swiper-wrapper">
                    ${this.getTeamMemberDataArray().map(member => `
                        <div class="swiper-slide team-modal__swiper-row">
                        <div class="team-modal__swiper-slide">
                                              <div class="team-modal__swiper-img">
                            <div class="team-modal__swiper-img-inner">
                                <img src="${member.memberImageUrl}" alt="${member.memberImageTitle}">
                            </div>
                        </div>
                        <div class="team-modal__swiper-col">
                            <h1 class="h4 single--h1">
                            ${member.name}
                            <span class="p">${member.jobTitle}</span>
                            </h1>
                            ${member.intro}
                        </div>
                        </div>
                      </div>
                    `).join('')}
                </div>
                <div class="team-modal__swiper-prev swiper-button-prev">
                    <svg class="icon icon-arrow-up">
                        <use xlink:href="#icon-arrow-up"></use>
                    </svg>
                </div>
                <div class="team-modal__swiper-next swiper-button-next">
                    <svg class="icon icon-arrow-up">
                        <use xlink:href="#icon-arrow-up"></use>
                    </svg>
                </div>
            </div>
        `)
        this.initSwiper(modal, card);
        modal.modalBox.addEventListener('click', (e) => e.stopPropagation());
    }

    initSwiper(modal, card) {
        const swiper = new Swiper(modal.modal.querySelector('.swiper-container'), {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.team-modal__swiper-next',
                prevEl: '.team-modal__swiper-prev',
            },
            initialSlide: this.teamImageCards.indexOf(card),
            breakpoints: {
                1920: {
                    width: 1600,
                },
                1400: {
                    width: 1200,
                },
                1024: {
                    width: 1024,
                },
                0: {
                    centeredSlides: true,
                }
            }
        });
    }
}

const teamImageCardsBoard = [...document.querySelectorAll('.js-team-image-card-board')];
const teamCardsSwiperModalBoard = new TeamCardsSwiperModal(teamImageCardsBoard);
teamCardsSwiperModalBoard.init();

const teamImageCardsExecutive = [...document.querySelectorAll('.js-team-image-card-executive')];
const teamCardsSwiperModalExecutive = new TeamCardsSwiperModal(teamImageCardsExecutive);
teamCardsSwiperModalExecutive.init();
